import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import Loader from 'app/custom/loader/Loader'
import ReactApexChart from 'react-apexcharts'
import {ApexOptions} from 'apexcharts'
import {useAppDispatch} from '../../../../redux/hooks'
import {studentTransportStatistic} from '../../../../redux/dphs/student-portal/StudentPortalSlice'

const StudentTransportStatistic = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const [loaderSummary, setLoaderSummary] = useState(true)
  const [statistics, setStatistics] = useState<any>({})

  const fetchData = async () => {
    const summaryRes: any = await dispatch(studentTransportStatistic())
    if (summaryRes.meta.requestStatus === 'fulfilled') {
      setStatistics(summaryRes.payload || {})
      setLoaderSummary(false)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const totalAmount = Number(statistics?.total_amount ?? 0)
  const totalPaid = Number(statistics?.total_paid ?? 0)
  const totalDue = Number(statistics?.total_due ?? 0)
  const totalDiscount = Number(statistics?.total_discount ?? 0)

  const donutSeries = [totalAmount, totalPaid, totalDue, totalDiscount]

  const donutOptions: ApexOptions = {
    chart: {type: 'donut', fontFamily: 'DejaVu Sans, sans-serif'},
    labels: [
      t('LABEL.TOTAL_AMOUNT'),
      t('LABEL.TOTAL_PAID'),
      t('LABEL.TOTAL_DUE'),
      t('LABEL.TOTAL_DISCOUNT'),
    ],
    colors: ['#009EF7', '#50CD89', '#7239EA', '#F1416C'],
    legend: {show: false},
    tooltip: {
      y: {formatter: (val: number) => val.toLocaleString()},
    },
  }

  if (loaderSummary) return <Loader />

  return (
    <div className='card shadow-sm border-0'>
      <div className='card-body d-flex'>
        <h4 className='fw-bold mb-4'>{t('CHART.TRANSPORT_SUMMARY')}</h4>

        <ReactApexChart options={donutOptions} series={donutSeries} type='donut' width={250} />

        <div className='ms-4 w-100'>
          <div className='d-flex justify-content-between bg-light-primary rounded px-3 py-2 mb-2'>
            <span className='fw-bold fs-4'>{t('LABEL.TOTAL_AMOUNT')}</span>
            <span className='fw-bold fs-4'>{totalAmount}</span>
          </div>

          <div className='d-flex justify-content-between bg-light-success rounded px-3 py-2 mb-2'>
            <span className='fw-bold text-success fs-4'>{t('LABEL.TOTAL_PAID')}</span>
            <span className='fw-bold text-success fs-4'>{totalPaid}</span>
          </div>

          <div className='d-flex justify-content-between bg-light-info rounded px-3 py-2 mb-2'>
            <span className='fw-bold text-info fs-4'>{t('LABEL.TOTAL_DUE')}</span>
            <span className='fw-bold text-info fs-4'>{totalDue}</span>
          </div>

          <div className='d-flex justify-content-between bg-light-danger rounded px-3 py-2'>
            <span className='fw-bold text-danger fs-4'>{t('LABEL.TOTAL_DISCOUNT')}</span>
            <span className='fw-bold text-danger fs-4'>{totalDiscount}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StudentTransportStatistic
